import { MijnRoute } from '../mijn-navigatie.model';

export const PIGGY_BANKS: MijnRoute = {
    path: 'spaarpot/:id',
    navigationEvent: 'toSpaarpot',
    regex: /^\/spaarpot\/[^/]+$/,
    webcomponent: 'mijn-spaarpot-webcomponent'
};
